import AnimalsOverview from '../../features/animals/layouts/overview';

// TSS vite/01 §"Pages are thin". /admin/toros — Toros (animales macho), tab de Animales.
// Reusa el catálogo de animales fijando sex=male. Detalle/edición viven en /admin/animals/:id.
export default function TorosPage() {
    return <AnimalsOverview sex="male" />;
}
